<template>
  <section class="section customer-reviews">
    <div class="glide">
      <h2 class="customer-reviews__title">What Our Customers Say</h2>
      <div class="glide__track" data-glide-el="track">
        <ul class="glide__slides">
          <li class="glide__slide">
            <!-- Customer Review, extract to own component -->
            <div class="customer-review">
              <div class="customer-review__image">
                <img src="../../assets/img/wael.jpeg" alt="Photo of Wael">
              </div>
              <blockquote class="customer-review__content">
                <p class="customer-review__content--text">
                  “The course was excellent. it was fun combined with science and business.
                  I really enjoyed it much and I have learned a lot. It was surely an added value to me on both personal and professional levels.
                  Matthias is an excellent team leader and course director with high values, manners, and patience as well, his knowledge is indeed remarkable.
                  The course had helped me on my journey to Renewable Energy. The knowledge, excursions, materials, and sightseeings gave me a solid touch on this interesting field.
                  I do recommend this course without hesitation if one needs hands-on-the-ground experience supported
                  with a top-notch entity like SRH and a well-structured program offered by PV-PA agency.
                  You're in good hands :-)”
                </p>
                <cite>
                  <small class="customer-review__content--name">
                    Wael Ahmed, Lead Sales Engineer AES Arabia Ltd
                  </small>
                </cite>
              </blockquote>
            </div>
            <!-- /Customer Review -->
          </li>
          <!-- <li class="glide__slide">
            <div class="customer-review">
              <div class="customer-review__image">
                <img src="../../assets/img/man.jpg" alt="">
              </div>
              <blockquote class="customer-review__content">
                <p class="customer-review__content--text">
                  “Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                  sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
                  nisi ut aliquip ex ea commodo consequat.”
                </p>
                <cite>
                  <small class="customer-review__content--name">
                    Max Mustermann, CEO of The Solar Company
                  </small>
                </cite>
              </blockquote>
            </div>
          </li>
          <li class="glide__slide">
            <div class="customer-review">
              <div class="customer-review__image">
                <img src="../../assets/img/man.jpg" alt="">
              </div>
              <blockquote class="customer-review__content">
                <p class="customer-review__content--text">
                  “Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                  sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
                  nisi ut aliquip ex ea commodo consequat.”
                </p>
                <cite>
                  <small class="customer-review__content--name">
                    Max Mustermann, CEO of The Solar Company
                  </small>
                </cite>
              </blockquote>
            </div>
          </li> -->
        </ul>
        <div class="glide__arrows" data-glide-el="controls">
          <a class="glide__arrow glide__arrow--left" data-glide-dir="<">
            <svg viewBox="0 0 16 28" fill="none">
              <path d="M15 1L1 14.8667L15 27" stroke="#E19A02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
          <a class="glide__arrow glide__arrow--right" data-glide-dir=">">
            <svg viewBox="0 0 16 28" fill="none">
              <path d="M1 27L15 13.1333L1 0.999999" stroke="#E19A02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
      <div class="glide__bullets" data-glide-el="controls[nav]">
        <a class="glide__bullet" data-glide-dir="=0"></a>
        <!-- <a class="glide__bullet" data-glide-dir="=1"></a>
        <a class="glide__bullet" data-glide-dir="=2"></a> -->
      </div>
    </div>
  </section>
</template>

<script>
import Glide from '@glidejs/glide/dist/glide';
import { Swipe } from '@glidejs/glide/dist/glide.modular.esm';

export default {
  name: 'customer-reviews',
  mounted() {
    const glide = new Glide('.glide', {
      type: 'carousel',
      Sizes: {
        slideWidth: 200,
      },
    });

    glide.mount({ Swipe });
  },
};
</script>
